import React from 'react';
import withSizes from 'react-sizes';
import { Link } from 'react-router-dom'
import { Tooltip } from '@rmwc/tooltip'

import SignInAndPWAButtons from './SignInAndPWAButtons'
import AppleSignInButton from './buttons/AppleSignInButton'
import CWIcon from './icons/CWIcon'
import JoinReferralButton from './buttons/JoinReferralButton';
import MobileInstallButtons from './MobileInstallButtons';
import { Capacitor } from '@capacitor/core';
import MovingAlertsList from './MovingAlertsList';

function Uvp(props) {
  return (
    <div className={props.isDesktop ? props.background : ''}>
      <section className="px-4 sm:px-6 lg:px-8">
        <div className={props.fullScreen ? "my-4" : "my-5"}>
          <div className="flex items-center justify-center pt-8 sm:pt-12">
            <div className="w-full">
              <div className="mx-auto w-full max-w-6xl">
                <div className="landing-notch-top flex items-center justify-center lg:justify-start">
                      <Link className="no-link inline-flex items-center" to="/">
                        <CWIcon theme='dark' size={34}/>
                        <span className="ml-2 text-black">
                          <span className="text-xl font-light">Crypto</span>
                          <span className="text-xl font-bold">Waves</span>
                        </span>
                      </Link>
                      {props.isBlogPost &&
                      <>
                        <span className='small ml-3'>
                          <a href="/">« Back To App</a>
                        </span>
                      </>
                      }
                </div>
                <div className="mt-8 flex flex-col items-center gap-10 lg:flex-row lg:items-start lg:gap-16">
                  <div className="w-full text-center lg:w-3/5 text-left">
                    {props.coin && !props.ios &&
                    <>
                      <h1 className={`my-4 font-extrabold tracking-tight text-gray-900 lg:text-left ${props.isDesktop ? "text-5xl sm:text-4xl" : "text-3xl"}`}>
                        {props.coin.coin} ({props.coin.name})&nbsp;
                        <span className='hl-silver'>RSI Scanner & Tracker</span>
                      </h1>
                      <p className="font-medium mt-3 text-base text-gray-600 sm:text-lg lg:text-left" style={{lineHeight: 1.7+'em'}}>
                       Get Personalized {props.coin.coin} <span className="hl-silver">Crypto RSI & Price Alerts 🚨</span> On Your Email, Telegram & Mobile. Know What Coins To <span className="hl-silver"><b>🟢 Buy</b></span> or <span className="hl-silver"><b>🔴 Sell</b></span> Next.
                       </p>
                    </>
                    }
                    {!props.coin && !props.ios &&
                    <>
                      <h1 className={`my-4 font-extrabold tracking-tight text-gray-900 lg:text-left ${props.isDesktop ? "text-3xl sm:text-4xl" : "text-3xl"} gradient`}>
                        Crypto Market&nbsp;
                         <span className='hl-silver'>RSI Scanner & Tracker</span>
                      </h1>
                      <p className="font-medium subtitle mt-3 text-base text-gray-600 sm:text-lg lg:text-left" style={{lineHeight: 1.7+'em'}}>
                         Get Personalized  <span className="hl-silver">Crypto RSI & Price Alerts 🚨 </span> On Your Email, Telegram & Mobile. Know What Coins To 🟢 <span className="hl-silver"><b>Buy</b></span> or 🔴 <span className="hl-silver"><b>Sell</b></span> Next.
                        </p>
                    </>
                    }

                    {props.showLogInButton && 
                    <div className="mt-6">
                      {!Capacitor.isNativePlatform() &&
                        <>
                          <SignInAndPWAButtons
                            ios={props.ios}
                            isMobile={props.isMobile}
                          />
                          <MobileInstallButtons isMobile={props.isMobile} align="left" />
                        </>
                      }
                    </div>
                    }
                  </div>
                  <div className="w-full lg:w-2/5">
                    {props.alerts && props.coins &&
                      <MovingAlertsList
                        isMobile={true}
                        landing={true}
                        coins={props.coins}
                        alerts={props.alerts}
                        visibleCount={3}
                        itemHeight={120}
                        durationMs={24000}
                      ></MovingAlertsList>
                    }
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      </section>
    </div>
  );
};

Uvp.defaultProps = {
  showLogInButton: true,
  ios: false,
  showScreenshots: true,
  showNav: false,
  showScrollTo: true,
  fullScreen: 'vh-100',
  h1: false,
  isBlogPost: false
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(Uvp);
